<text-input [(value)]="text" [placeHolder]="placeHolder" [prefix]="prefix" [prefixIcon]="prefixIcon"></text-input>
